var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHorizontalPoints = function SvgHorizontalPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7ZM16 13a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm10.5 0a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Z",
    fill: "#fff"
  })));
};
export default SvgHorizontalPoints;